import loadable from '@loadable/component'

export default [
  {
    path: '/HiyaFarm2022',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HiyaFarm2022" */ '~/pages/HiyaFarm2022'
        )
    ),
  },
]
